/**
 * @freesewing/plugin-svgattr | v2.16.2
 * A FreeSewing plugin to set SVG attributes
 * (c) 2021 Joost De Cock <joost@joost.at> (https://github.com/joostdecock)
 * @license MIT
 */
var e={name:"@freesewing/plugin-svgattr",version:"2.16.2",hooks:{preRender:function(e,t){if(!1===e.attributes.get("freesewing:plugin-svgattr")){for(let r of Object.keys(t))e.attributes.add(r,t[r]);e.attributes.add("freesewing:plugin-svgattr","2.16.2")}}}};export default e;
//# sourceMappingURL=index.mjs.map
